import { IconName } from '../components/v2BaseComponents/Icon';

export type EntityIcon = {
    iconName: IconName;
};

const entityIcons: Record<string, EntityIcon> = {
    medication: {
        iconName: 'Medications',
    },
    condition: {
        iconName: 'Conditions',
    },
    visit: {
        iconName: 'Visits',
    },
    allergy: {
        iconName: 'Allergies',
    },
    lab: {
        iconName: 'Labs',
    },
    careTeam: {
        iconName: 'CareTeam',
    },
    collaborator: {
        iconName: 'Users',
    },
    attachments: {
        iconName: 'Paperclip',
    },
    comment: {
        iconName: 'MessageSquare',
    },
    note: {
        iconName: 'Edit2',
    },
    imaging: {
        iconName: 'Imaging',
    },
    vaccination: {
        iconName: 'Vaccinations',
    },
    procedure: {
        iconName: 'Procedures',
    },
    files: {
        iconName: 'FileText',
    },
};

export default entityIcons;
